import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import './notaryDeclaration.css';
import { setImage, setShowError, setErrorType, setErrorMessage } from "../../redux/actionCreators";
import { connect } from "react-redux";
import config from '../../config/config';
/* import { IdentityMeeting } from '@autofact/identity-meet-react-component'; */
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
class NotaryDeclaration extends Component {
    TO_SECONDS = 1000;
    DEFAULT_URL = config.notary_declaration_video_url;
    constructor(props) {
        super(props);
        this.state = {
            showNextButton: false,
            showEstablishedMessage: false,
            resultConnectionText: null,
            code: null,
        }
    }

    componentDidMount() {
        this.props.setImage(this.props.code);
    }

    componentWillUnmount() {
        if (this.nextGeneralButtonTimer) {
            clearInterval(this.nextGeneralButtonTimer);
        }
        if (this.nextButtonTimer) {
            clearInterval(this.nextButtonTimer);
        }
    }

    onNotaryJoined = () => {
        this.setState({
            showEstablishedMessage: true,
        });

        if (this.nextGeneralButtonTimer) {
            clearInterval(this.nextGeneralButtonTimer);
        }
    }

    onMessageCode = (data) => {
        console.log('received data',data)
        this.setState({
            code: 'CLIENT-OK',
        });

        console.log('onMessageCode', data);
        if (data === 'NOTARY-OK') {
            this.setState({
                showNextButton: true,
            });
        }
        if (data === 'NOTARY-REJECT') {
            this.props.setShowError(true);
            this.props.setErrorMessage({
                title: '¡Oh oh! Ha ocurrido un error',
                principalMessage: 'Lamentablemente, se debe realizar nuevamente el proceso. Asegúrate que en el video la persona que se presenta sea la misma de la firma y lea correctamente la declaración.',
            });
        }
        if (data === 'NOTARY-NOK') {
            this.state({
                resultConnectionText: 'Tuvimos problemas con la validación. Por favor contáctate con nuestro equipo de soporte soporte.transferencia@autofact.cl'
            });
        }

        if (this.nextGeneralButtonTimer) {
            clearInterval(this.nextGeneralButtonTimer);
        }
    }

    handleButtonNextClick = (event) => {
        this.props.setImage(this.props.code);
        this.props.nextStep(event);
    }

    getNextButton = () => {
        return null;
    };

    getConnectionText = () => {
        if (this.state.showEstablishedMessage) {
            return (
                <Col xs={12} className={'instruction-text-conection'}>
                                        <p><strong>Conexión establecida.</strong></p>
                </Col>
            );
        } else {
            if (this.state.showNextButton) {
                return (
                    <Col xs={12} className={'instruction-text-conection'}>
                        <p><strong>No se ha podido establecer la conexión.</strong></p>
                    </Col>
                );
            } else {
                return (
                    <Col xs={12} className={'instruction-text-conection'}>
                        <p><strong>Esperando por conexión...</strong></p>
                    </Col>
                );
            }

        }
    }

    getResultConnectionText = () => {
        if (this.state.resultConnectionText) {
            return (
                <Col xs={12} className={'instruction-text'}>
                    <p>{this.state.resultConnectionText}</p>
                </Col>
            );
        }
    }

    getNotaryInfo = () => {
        return (
            <Col xs={12} className={'instruction-text-notary-name'}>
                <p><strong>Su proceso es con la {this.props.stepInfo.notaryText}</strong></p>
            </Col>
        );
    }

    render() {
        return (
            <div className={'notary-declaration'}>
                
                <PageWithFooter
                    footer={this.state.showNextButton ? (
                        <FooterContainer>
                            <MainButton
                                onClick={this.handleButtonNextClick}
                                className={'next-button'}
                            />
                        </FooterContainer>
                    ) : null}
                >
                <Grid>
                    <Row>
                        <Col xs={12}>
                            <p className='instruction-text'>
                                Por favor cuando se establezca la comunicación realiza la siguiente declaración:
                            </p>
                            <p className='declaration-text'>
                                <b>{this.props.stepInfo.information}</b>
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className={'video-container'}>
                            {this.props.stepInfo.meetingInfo && (
                                {/* <IdentityMeeting  
                                code={this.state.code}
                                meetingInfo={this.props.stepInfo.meetingInfo}
                                remoteLogging={true}
                                singleView={false}
                                onNotaryJoined={this.onNotaryJoined}
                                onMessageCode={this.onMessageCode}
                                /> */}
                            )}
                        </Col>
                        {this.getNotaryInfo()}
                        {this.getConnectionText()}
                        {this.getResultConnectionText()}
                    </Row>
                </Grid>
                </PageWithFooter>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        image: state.image,
        showError: state.showError,
        setErrorType: state.setErrorType,
        stepInfo: state.stepInfo,
        code: state.code,
        errorMessage: state.errorMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setErrorMessage(errorMessage) {
            dispatch(setErrorMessage(errorMessage))
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotaryDeclaration);
